import { render, staticRenderFns } from "./SingleOption.vue?vue&type=template&id=88116cfe"
import script from "./SingleOption.vue?vue&type=script&lang=js"
export * from "./SingleOption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports